<script>

</script>

<h1>Egg Fries Website!</h1>

<p>This web will teach you how to cook 2 types of Egg!</p>
<p>1. Omelet Egg!</p>
<p>2. Fried Egg!</p>
<p><b>Look at the Top of the web to see links you can click!</b></p>
<img src="images/Home.jpg" alt="">